import React, {createContext, useState} from "react";
import PMSAdditionalBalanceServices from "../../services/pms_services/PMSAdditionalBalanceServices";
import Notification from "../../components/common/Notification";

export const PMSAdditionalBalanceContext = createContext("PMSAdditionalBalanceContext");

const PMSAdditionalBalanceContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [loadingCreate, setLoadingCreate] = useState(false);
    const [loadingUpdate, setLoadingUpdate] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    const [additionalBalances, setAdditionalBalances] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);

    const getAllAdditionalBalancesByPharmacyId = async (params) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSAdditionalBalanceServices.getAllAdditionalBalancesByPharmacyId(params);
            setAdditionalBalances(res.data.content);
            setTotalElements(res.data.totalElements);
            setTotalAmount(res.data.totalAmount || 0);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            const _error = error.response?.data?.message || error.message || "Something went wrong.";
            setErrorMsg(_error);
            Notification("error", "ERROR", _error);
            return false;
        }
    };

    const createAdditionalBalance = async (pharmacyId, data) => {
        try {
            setLoadingCreate(true);
            setErrorMsg("");
            await PMSAdditionalBalanceServices.createAdditionalBalance(pharmacyId, data);
            Notification("success", "Created", "Additional balance created successfully.");
            setLoadingCreate(false);
            return true;
        } catch (error) {
            setLoadingCreate(false);
            const _error = error.response?.data?.message || error.message || "Something went wrong.";
            setErrorMsg(_error);
            Notification("error", "ERROR", _error);
            return false;
        }
    };

    const updateAdditionalBalance = async (id, pharmacyId, data) => {
        try {
            setLoadingUpdate(true);
            setErrorMsg("");
            await PMSAdditionalBalanceServices.updateAdditionalBalance(id, pharmacyId, data);
            Notification("success", "Updated", "Additional balance updated successfully.");
            setLoadingUpdate(false);
            return true;
        } catch (error) {
            setLoadingUpdate(false);
            const _error = error.response?.data?.message || error.message || "Something went wrong.";
            setErrorMsg(_error);
            Notification("error", "ERROR", _error);
            return false;
        }
    };

    const deleteAdditionalBalance = async (id, pharmacyId) => {
        try {
            setLoadingDelete(true);
            setErrorMsg("");
            await PMSAdditionalBalanceServices.deleteAdditionalBalance(id, pharmacyId);
            Notification("success", "Deleted", "Additional balance deleted successfully.");
            setLoadingDelete(false);
            return true;
        } catch (error) {
            setLoadingDelete(false);
            const _error = error.response?.data?.message || error.message || "Something went wrong.";
            setErrorMsg(_error);
            Notification("error", "ERROR", _error);
            return false;
        }
    };

    return (
        <PMSAdditionalBalanceContext.Provider
            value={{
                loading,
                loadingCreate,
                loadingUpdate,
                loadingDelete,
                errorMsg,
                additionalBalances,
                totalElements,
                totalAmount,
                getAllAdditionalBalancesByPharmacyId,
                createAdditionalBalance,
                updateAdditionalBalance,
                deleteAdditionalBalance,
            }}
        >
            {children}
        </PMSAdditionalBalanceContext.Provider>
    );
};

export default PMSAdditionalBalanceContextProvider;
